export enum PromptType {
  interactiveElement = 'interactive_element_prompt',
  postRoomState = 'post_room_state_prompt',
  rubric = 'rubric_prompt',
}

export enum PromptVersionStatus {
  /** mutable, has not been used (installed) -> must be moved to published to be used */
  draft = 0,
  /** immutable and can be 'installed' (changed to current prompt version) */
  published = 1,
  /** previously published prompts that are no longer installed */
  archived = 2,
}
